import React, { useState, useEffect, useRef } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Alert,
  Label,
  Input,
  Badge,
  FormGroup
} from "reactstrap"
import { post, get } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { ITEMS_PER_PAGE } from "helpers/pagination_helper"
import Loader from "common/loader"
import { ImageBaseUrl } from "helpers/file_upload_helper"
import {
  ORDERS_SEARCH,
  ORDER_STATS,
  CITIES_SEARCH,
  DISTRICTS_SEARCH,
  STATUS_SEARCH,
  DELIVERY_TYPE_SEARCH,
  DRIVERS_SEARCH,
  NEAREST_EXPRESS_DRIVER,
  EXPRESS_DRIVER_ROUTE, PAYMENT_METHODS_SEARCH
} from "helpers/api_endpoints"
import QRCode from "react-qr-code"
import Select from "react-select"
import NoImage from "assets/images/no-image.png"
import moment from "moment"
import { set } from "lodash"
//meta title
document.title = "Orders"
const OrdersList = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const user = JSON.parse(localStorage.getItem("authUser")).user
  const [orderId, setOrderId] = useState("")
  const [refId, setRefId] = useState("")
  const [orderStatusId, setOrderStatusId] = useState(null)
  const [orderStatus, setOrderStatus] = useState([])
  const [name, setName] = useState("")
  const [customerTypeId, setCustomerTypeId] = useState("")
  const [orderDateFrom, setOrderDateFrom] = useState("")
  const [orderDateTo, setOrderDateTo] = useState("")
  const [orderDeliveryDateFrom, setOrderDeliveryDateFrom] = useState("")
  const [orderDeliveryDateTo, setOrderDeliveryDateTo] = useState("")
  const [orderTime, setOrderTime] = useState("")
  const [orderDeliveryTime, setOrderDeliveryTime] = useState("")
  const [addressFromId, setAddressFromId] = useState(0)
  const [addressToId, setAddressToId] = useState("")
  const [shipmentTypeId, setShipmentTypeId] = useState("")
  const [currentStatusId, setCurrentStatusId] = useState("")
  const [shipmentTypeOptions, setShipmentTypeOptions] = useState("")
  const [items, setItems] = useState([])
  const [services, setServices] = useState([])
  const [orders, setOrders] = useState([])
  const [cOrders, setCOrders] = useState([])
  const [ordersLate, setOrdersLate] = useState([])

  //Types
  const [customerTypes, setCustomerTypes] = useState([
    { value: "1", label: "All" },
    { value: "2", label: "User" },
    { value: "3", label: "Partner" },
  ])
  const [cities, setCities] = useState([])
  const [districts, setDistricts] = useState([])
  const [deliveryTypes, setDeliveryTypes] = useState([])
  const [drivers, setDrivers] = useState([])
  const [stats, setStats] = useState([])
  const [paymentMethods, setPaymentMethods] = useState([])

  //
  const [fromCityId, setFromCityId] = useState("")
  const [fromDistrictId, setFromDistrictId] = useState("")
  const [toCityId, setToCityId] = useState("")
  const [toDistrictId, setToDistrictId] = useState("")
  const [deliveryTypeId, setDeliveryTypeId] = useState("")
  const [refCategoryId, setRefCategoryId] = useState("")
  const [driverId, setDriverId] = useState("")
  const [packagesNo, setpackagesNo] = useState(0)
  const [lateFilter, setLateFilter] = useState("all")
  const [loading, setLoading] = useState(true)
  const [filters, setFilters] = useState({ admin: 1 })
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [timer, setTimer] = useState(null)
  const [paidById, setPaidById] = useState(null)
  const [paymentMethodId, setPaymentMethodId] = useState(null)
  const [totalPages, setTotalPages] = useState(0)
  const [groupDrivers, setGroupDrivers] = useState(0)
  const [search, setSearch] = useState(false)
  const [successMsg, setsuccessMsg] = useState("")
  const formRef = useRef(null)

  let timeout = null;

  const calcOrderTimes = time => {
    const abTime = Math.abs(time)
    const hour = Math.trunc(abTime / 60)
    const min = abTime - hour * 60
    return { time, abTime, hour, min }
  }

  const refCategories = [{ value: "0", label: "All" }, { value: "3", label: "Donation" }, { value: "168", label: "Gift" }
    , { value: "232", label: "30 Min" }, { value: "99", label: "General" }]

  const paidByOptions = [{ value: "0", label: "All" }, { value: "1", label: "By Partner" }, { value: "2", label: "By Cargo" }]

  const pageSizeOptions = [{ value: "10", label: "10" }, { value: "30", label: "30" }, { value: "100", label: "100" }, { value: "1000", label: "1000" }]


  useEffect(() => {
    successMessage()
    setLoading(true);
    setOrders([]);
    post(`${ORDERS_SEARCH}?paginate=${pageSize}&page=${page}`, filters)
      .then(async response => {
        const data = response.data
        // const orders = data.data
        //   .map(async order => {
        //     if (order.currentStatusId == 7) {
        //     } else if (order.driverId)
        //       order.expectedDeliveryDuration = await getNearestDriver(
        //         order.driverId,
        //         order
        //       )
        //     else
        //       order.expectedDeliveryDuration = await getNearestFromDrivers(
        //         order
        //       )
        //     if (
        //       order.orderDate &&
        //       order.orderTime &&
        //       order.partnerBranch?.bookedAssignmentTime !== undefined
        //     ) {
        //       const calcTime = calcOrderTimes(
        //         Math.round(
        //           moment
        //             .duration(
        //               moment(order.orderDate + " " + order.orderTime).diff(
        //                 moment().add(
        //                   order.partnerBranch.bookedAssignmentTime,
        //                   "minutes"
        //                 )
        //               )
        //             )
        //             .asMinutes()
        //         )
        //       )

        //       order.late = {
        //         hour: calcTime.hour,
        //         min: calcTime.min,
        //         pos: calcTime.time >= 0,
        //         val:
        //           (calcTime.time < 0 ? "-" : "") +
        //           (calcTime.hour < 10 ? "0" + calcTime.hour : calcTime.hour) +
        //           ":" +
        //           (calcTime.min < 10 ? "0" + calcTime.min : calcTime.min),
        //       }
        //     } else {
        //       if(!order.late){
        //         order.late = { val: "NaN:NaN", pos: true, hour: 0, min: 0 }
        //       }
        //       if (filters.status === "all") {
        //         order.late = { val: "--:--", pos: true, hour: 0, min: 0 }
        //       }
        //     }

        //     return order
        //   })
        //   .filter(el => el != undefined)
        setOrders(data.data)
        setTotalPages(data.pagination.totalPages)
        setPage(data.pagination.currentPage)
        setLoading(false)
        Promise.all(orders).then(res => {
          const validOrders = res.filter(o => o !== null)
          console.log('validOrders', validOrders.length)
          setOrdersLate(validOrders)
        })
        setOrders(data.data)
        setCOrders(data.data)

      })
      .catch(error => {
        console.log(error)
        if (error.response.status == 401) {
          navigate('/login');
        }
      })
  }, [page, search, pageSize])

  useEffect(() => {
    get(`${ORDER_STATS}`)
      .then(response => {
        const data = response.data.data
        setStats(data)
      })
      .catch(error => {
        console.log(error)
      })
    post(PAYMENT_METHODS_SEARCH)
      .then(response => {
        const temp = response.data.map(el => {
          return { value: el.id, label: el.name }
        });
        setPaymentMethods(temp);
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  useEffect(() => {
    console.log('groupDrivers changed', groupDrivers);
    if (groupDrivers == 1) {
      let temp = [...orders];
      temp = temp.sort((a, b) => {
        return b.driverId < a.driverId ? 1 : -1
      })
      setOrders([...temp]);
    }
    else {
      setOrders([...cOrders]);
    }
  }, [groupDrivers])

  useEffect(() => {
    successMessage()
    post(`${CITIES_SEARCH}`)
      .then(response => {
        const data = response.data
        setCities(
          data.map((city, index) => {
            return { value: city.id, label: city.nameTranslated }
          })
        )
      })
      .catch(error => {
        console.log(error)
        if (error.response.status == 400) {
          navigate("/logout")
        }
      })
  }, [])

  useEffect(() => {
    successMessage()
    post(`${DISTRICTS_SEARCH}`)
      .then(response => {
        const data = response.data
        setDistricts(
          data.map((district, index) => {
            return { value: district.id, label: district.nameTranslated }
          })
        )
      })
      .catch(error => {
        console.log(error)
        if (error.response && error.response.status == 400) {
          navigate("/logout")
        }
      })
    post(`${DELIVERY_TYPE_SEARCH}`)
      .then(response => {
        const data = response.data
        setDeliveryTypes(
          data.map((dtype, index) => {
            return { value: dtype.id, label: dtype.nameTranslated }
          })
        )
      })
      .catch(error => {
        console.log(error)
        if (error.response.status == 400) {
          navigate("/logout")
        }
      })
    post(`${DRIVERS_SEARCH}`)
      .then(response => {
        const data = response.data
        setDrivers(
          data.map((driver, index) => {
            return { value: driver.id, label: driver.name }
          })
        )
      })
      .catch(error => {
        console.log(error)
        if (error.response.status == 400) {
          navigate("/logout")
        }
      })
  }, [])

  useEffect(() => {
    successMessage()
    post(`${STATUS_SEARCH}`)
      .then(response => {
        const data = response.data
        setOrderStatus(
          data.map((status, index) => {
            return { value: status.id, label: status.nameTranslated }
          })
        )
      })
      .catch(error => {
        console.log(error)
        if (error.response.status == 400) {
          navigate("/logout")
        }
      })
  }, [])

  const successMessage = () => {
    if (location.state) {
      setsuccessMsg(location.state.successMsg)
      setTimeout(() => {
        location.state.successMsg = ""
        setsuccessMsg("")
      }, 2000)
    }
  }

  const handleFilter = (type, value) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      const filtvalues = { ...filters };
      if (value) {
        switch (type) {
          case "orderId":
            setOrderId(value)
            filtvalues.id = value
            break
          case "customerTypeId":
            setCustomerTypeId(value)
            filtvalues.customerTypeId = value
            break
          case "paymentMethodId":
            setPaymentMethodId(value)
            filtvalues.paymentMethodId = value
            break
          case "paidBy":
            setPaidById(value)
            filtvalues.paidById = value
            break
          case "name":
            setName(value)
            filtvalues.name = value
            break
          case "refId":
            setRefId(value)
            filtvalues.refId = value
            break
          case "refCategoryId":
            setRefCategoryId(value)
            filtvalues.refCategoryId = value
            break
          case "orderStatusId":
            setOrderStatusId(value)
            filtvalues.orderStatusId = value
            break
          case "packagesNo":
            setpackagesNo(value)
            filtvalues.packagesNo = value
            break
          case "fromCityId":
            setFromCityId(value)
            filtvalues.fromCityId = value
            break
          case "fromDistrictId":
            setFromDistrictId(value)
            filtvalues.fromDistrictId = value
            break
          case "toCityId":
            setToCityId(value)
            filtvalues.toCityId = value
            break
          case "toDistrictId":
            setToDistrictId(value)
            filtvalues.toDistrictId = value
            break
          case "deliveryTypeId":
            setDeliveryTypeId(value)
            filtvalues.deliveryTypeId = value
            break
          case "orderDateFrom":
            setOrderDateFrom(value)
            break
          case "orderDateTo":
            setOrderDateTo(value)
            filtvalues.orderDateFrom = orderDateFrom
            filtvalues.orderDateTo = value
            break
          case "orderTime":
            setOrderTime(value)
            filtvalues.orderTime = value
            break
          case "driverId":
            setDriverId(value)
            filtvalues.driverId = value
            break
          case "orderDeliveryDateFrom":
            setOrderDeliveryDateFrom(value)
            filtvalues.orderDeliveryDateFrom = value
            // sending the current date if orderDeliveryDateTo is not set
            filtvalues.orderDeliveryDateTo = orderDeliveryDateTo ? orderDeliveryDateTo : new Date().toISOString().split("T")[0]
            break
          case "orderDeliveryDateTo":
            setOrderDeliveryDateTo(value)
            filtvalues.orderDeliveryDateFrom = orderDeliveryDateFrom
            filtvalues.orderDeliveryDateTo = value
            break
          case "orderDeliveryTime":
            setOrderDeliveryTime(value)
            filtvalues.orderDeliveryTime = value
            break
          default:
            break
        }
      }
      setFilters(filtvalues)
      timeout = null
    }, 1000)
  }

  const getNearestDriver = async (driverId, order) => {
    return post(EXPRESS_DRIVER_ROUTE, {
      lat: order.addressFrom?.latitude,
      lng: order.addressFrom?.longitude,
      driverId,
    })
      .then(response => {
        if (!response.data) return
        if (response.code == 200) {
          const min = response.data.duration?.seconds
            ? Math.round(response.data.duration?.seconds / 60)
            : " unknown "
          return min
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  const getNearestFromDrivers = async order => {
    return post(NEAREST_EXPRESS_DRIVER, {
      lat: order.addressTo?.latitude,
      lng: order.addressTo?.longitude,
    })
      .then(response => {
        if (response.code == 200 && response.data) {
          const min = response.data.duration
            ? response.data.duration
            : " unknown "
          return min
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1)
    }
  }

  // client-side filtering
  const lateOptions = [
    { value: "all", label: "All" },
    { value: "late", label: "Late" },
    { value: "notlate", label: "Not Late" },
  ]

  const displayedOrders = orders.filter(order => {
    if (!lateFilter || lateFilter === "all") return true

    const val = order.late?.val

    if (!val || val === "NaN:NaN") return false

    const isLate = val.startsWith("-")
    const isNeutral = val === "--:--"

    if (lateFilter === "late") return isLate
    if (lateFilter === "notlate") return !isLate || isNeutral

    return true
  })

  const handleClearFilters = () => {

    formRef.current?.reset()


    setCustomerTypeId(null)
    setOrderStatusId(null)
    setFromCityId(null)
    setFromDistrictId(null)
    setToCityId(null)
    setToDistrictId(null)
    setDeliveryTypeId(null)
    setDriverId(null)
    setRefCategoryId(null)
    setPaymentMethodId(null)
    setPaidById(null)
    setLateFilter("all")


    setFilters({ admin: 1 })
    setPage(1)


    setSearch(prev => !prev)
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Orders" />
          <Row>
            <Col xl={12}>
              <Card>
                <br></br>
                {successMsg ? (
                  <Alert style={{ margin: "25px" }} color="success">
                    {successMsg}
                  </Alert>
                ) : null}
                <CardTitle>
                  <Link to="/orders/add">
                    <button
                      style={{ float: "right", marginRight: "20px" }}
                      className="btn btn-sm btn-primary"
                    >
                      <i className="dripicons-plus"></i> &nbsp;
                      <Trans>Create</Trans>
                    </button>
                  </Link>
                </CardTitle>

                <form ref={formRef}>
                  <div style={{ margin: "25px" }}>
                    <div className="row">
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Order ID</Trans>
                        </Label>
                        <Input
                          name="orderId"
                          id="orderId"
                          className="form-control"
                          placeholder=""
                          type="text"
                          onChange={e => handleFilter("orderId", e.target.value)}
                        ></Input>
                      </div>
                      {!user.partner ? (
                        <div className="form-group col-md-4 mt-2">
                          <Row>
                            <div className="form-group col-md-6 mt-2">
                              <Label className="form-label">
                                <Trans>Customer Type</Trans>
                              </Label>
                              <Select
                                name="customerTypeId"
                                value={customerTypes.find(
                                  el => el.value == customerTypeId
                                ) || null}
                                options={customerTypes}
                                className="form-control select2"
                                onChange={e =>
                                  handleFilter("customerTypeId", e.value)
                                }
                              />
                            </div>

                            <div className="form-group col-md-6 mt-2">
                              <Label className="form-label">
                                <Trans>Partner/User Name</Trans>
                              </Label>
                              <Input
                                name="name"
                                className="form-control"
                                placeholder=""
                                type="text"
                                onChange={e =>
                                  handleFilter("name", e.target.value)
                                }
                              ></Input>
                            </div>
                          </Row>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Order Status</Trans>
                        </Label>
                        <Select
                          name="orderStatusId"
                          value={orderStatus.find(
                            el => el.value == orderStatusId
                          ) || null}
                          options={orderStatus}
                          className="form-control select2"
                          onChange={e => handleFilter("orderStatusId", e.value)}
                        />
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Packages Number</Trans>
                        </Label>
                        <Input
                          name="packagesNo"
                          className="form-control"
                          placeholder=""
                          type="text"
                          onChange={e =>
                            handleFilter("packagesNo", e.target.value)
                          }
                        ></Input>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Pickup Location City</Trans>
                        </Label>
                        <Select
                          name="fromCityId"
                          value={cities.find(el => el.value == fromCityId) || null}
                          options={cities}
                          className="form-control select2"
                          onChange={e => handleFilter("fromCityId", e.value)}
                        />
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Pickup Location District</Trans>
                        </Label>
                        <Select
                          name="fromDistrictId"
                          value={districts.find(el => el.value == fromDistrictId) || null}
                          options={districts}
                          className="form-control select2"
                          onChange={e => handleFilter("fromDistrictId", e.value)}
                        />
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Drop Location City</Trans>
                        </Label>
                        <Select
                          name="toCityId"
                          value={cities.find(el => el.value == toCityId) || null}
                          options={cities}
                          className="form-control select2"
                          onChange={e => handleFilter("toCityId", e.value)}
                        />
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Drop Location District</Trans>
                        </Label>
                        <Select
                          name="toDistrictId"
                          value={districts.find(el => el.value == toDistrictId) || null}
                          options={districts}
                          className="form-control select2"
                          onChange={e => handleFilter("toDistrictId", e.value)}
                        />
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Reference Id</Trans>
                        </Label>
                        <Input
                          name="refId"
                          className="form-control"
                          placeholder=""
                          type="text"
                          onChange={e => handleFilter("refId", e.target.value)}
                        ></Input>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Order Type</Trans>
                        </Label>
                        <Select
                          name="deliveryTypeId"
                          value={deliveryTypes.find(
                            el => el.value == deliveryTypeId
                          ) || null}
                          options={deliveryTypes}
                          className="form-control select2"
                          onChange={e => handleFilter("deliveryTypeId", e.value)}
                        />
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Order Creation Date From</Trans>
                        </Label>
                        <Input
                          name="orderDateFrom"
                          className="form-control"
                          placeholder=""
                          type="date"
                          onChange={e =>
                            handleFilter("orderDateFrom", e.target.value)
                          }
                        ></Input>
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Order Creation Date To</Trans>
                        </Label>
                        <Input
                          name="orderDateTo"
                          className="form-control"
                          placeholder=""
                          type="date"
                          onChange={e =>
                            handleFilter("orderDateTo", e.target.value)
                          }
                        ></Input>
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Order Creation Time</Trans>
                        </Label>
                        <Input
                          name="orderTime"
                          className="form-control"
                          placeholder=""
                          type="time"
                          onChange={e =>
                            handleFilter("orderTime", e.target.value)
                          }
                        ></Input>
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Order Delivery Date From</Trans>
                        </Label>
                        <Input
                          name="orderDeliveryDateFrom"
                          className="form-control"
                          placeholder=""
                          type="date"
                          onChange={e =>
                            handleFilter("orderDeliveryDateFrom", e.target.value)
                          }
                        ></Input>
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Order Delivery Date To</Trans>
                        </Label>
                        <Input
                          name="orderDeliveryDateTo"
                          className="form-control"
                          placeholder=""
                          type="date"
                          onChange={e =>
                            handleFilter("orderDeliveryDateTo", e.target.value)
                          }
                        ></Input>
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Order Delivery Time</Trans>
                        </Label>
                        <Input
                          name="orderDeliveryTime"
                          className="form-control"
                          placeholder=""
                          type="time"
                          onChange={e =>
                            handleFilter("orderDeliveryTime", e.target.value)
                          }
                        ></Input>
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Driver Name</Trans>
                        </Label>
                        <Select
                          name="driverId"
                          value={drivers.find(el => el.value == driverId) || null}
                          options={drivers}
                          className="form-control select2"
                          onChange={e => handleFilter("driverId", e.value)}
                        />
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Reference Category</Trans>
                        </Label>
                        <Select
                          name="refCategoryId"
                          value={refCategories.find(el => el.value == refCategoryId) || null}
                          options={refCategories}
                          className="form-control select2"
                          onChange={e => handleFilter("refCategoryId", e.value)}
                        />
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Reference Payment Method</Trans>
                        </Label>
                        <Select
                          name="paymentMethodId"
                          value={paymentMethods.find(el => el.value == paymentMethodId) || null}
                          options={paymentMethods}
                          className="form-control select2"
                          onChange={e => handleFilter("paymentMethodId", e.value)}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Late Orders</Trans>
                        </Label>
                        <Select
                          name="lateOrders"
                          value={lateOptions.find(el => el.value == lateFilter) || null}
                          options={lateOptions}
                          className="form-control select2"
                          onChange={e => setLateFilter(e.value)}
                        />
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Paid by</Trans>
                        </Label>
                        <Select
                          name="paidBy"
                          value={paidByOptions.find(el => el.value == paidById) || null}
                          options={paidByOptions}
                          className="form-control select2"
                          onChange={e => handleFilter('paidBy', e.value)}
                        />
                      </div>


                    </div>
                    {/* <div className="form-group col-md-6 ml-2">
                                        <button color="secondary" onClick={()=>{setDeliveryTypeId(0)}}>Refresh</button>
                                    </div> */}
                  </div>
                </form>
                <div className="row">
                  <div className="form-group col-md-3 mt-2 ">
                    <button
                      name="allocatedCar"
                      className="form-control bg-primary text-white"
                      placeholder=""
                      type="button"
                      value="Search"
                      onClick={() => { setSearch(!search) }}
                    >
                      <Trans>Search</Trans>
                    </button>
                  </div>

                  <div className="form-group col-md-3 mt-2">
                    <button
                      className="form-control bg-secondary text-white"
                      type="button"
                      onClick={handleClearFilters}
                    >
                      <Trans>Clear Filters</Trans>
                    </button>
                  </div>

                </div>
                <Row>
                  <Col xl={12}>
                    <div className="row mr-12">
                      {stats && stats.length ? (
                        stats.map((st, index) => (
                          <div key={index} className="col-md-2 mt-2">
                            <h4>
                              <Badge
                                style={{ marginLeft: "10px" }}
                                color="info"
                              >
                                {
                                  orderStatus.find(
                                    el => el.value == st.currentStatusId
                                  )?.label
                                }
                              </Badge>
                            </h4>
                            <h5>
                              <Badge
                                style={{ marginLeft: "10px" }}
                                color="primary"
                              >
                                {st.count}
                              </Badge>
                            </h5>
                          </div>
                        ))
                      ) : (
                        <></>
                      )}
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Page Size</Trans>
                        </Label>
                        <Select
                          name="pageSize"
                          value={pageSizeOptions.find(el => el.value == pageSize)}
                          options={pageSizeOptions}
                          className="form-control select2"
                          onChange={e => setPageSize(e.value)}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <CardBody>
                  {loading ? (
                    <div className="text-center">
                      <Loader></Loader>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <Table
                        className="table table-bordered mb-0"
                        style={{ "--bs-table-bg": "transparent" }}
                      >
                        <thead>
                          <tr>
                            <th>
                              <Trans>ID</Trans>
                            </th>
                            {!user.partner ? (
                              <th className="text-center">
                                <Trans>Customer Type / Name</Trans>
                              </th>
                            ) : null}
                            {user.partner ? (
                              <th>
                                <Trans>Branch</Trans>
                              </th>
                            ) : null}
                            <th>
                              <Trans>Pickup Location</Trans>
                            </th>
                            <th>
                              <Trans>Drop Location</Trans>
                            </th>
                            <th>
                              <Trans>Delivery Type</Trans>
                            </th>
                            <th>
                              <Trans>Create Date</Trans>
                            </th>
                            <th>
                              <Trans>Created Time</Trans>
                            </th>
                            <th>
                              <Trans>Driver Name</Trans>
                            </th>
                            <th>
                              <Trans>Delivery Date</Trans>
                            </th>
                            <th>
                              <Trans>Delivery Time</Trans>
                            </th>
                            {/* <th>
                              <Trans>Estimated pickup time</Trans>
                            </th>
                            <th>
                              <Trans>Estimated delivery time</Trans>
                            </th> */}
                            <th>
                              <Trans>Current Status</Trans>
                            </th>
                            {/* <th>
                              <Trans>time Status</Trans>
                            </th> */}
                            <th>
                              <Trans>Reference Category</Trans>
                            </th>
                            <th>
                              <Trans>Packages Number</Trans>
                            </th>
                            <th>
                              <Trans>Paid</Trans>
                            </th>
                            <th>
                              <Trans>Payment method</Trans>
                            </th>
                            <th>
                              <Trans>Reference Id</Trans>
                            </th>
                            <th>
                              <Trans>Reference Amount</Trans>
                            </th>
                            <th>
                              <Trans>QR</Trans>
                            </th>
                            <th>
                              <Trans>Action</Trans>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {displayedOrders.map((order, index) => (
                            <tr
                              key={index}
                              className={
                                order.currentStatusId == 7
                                  ? "bg-danger"
                                  : order.currentStatusId == 6
                                    ? "bg-success"
                                    : ""
                              }
                              style={
                                order.currentStatusId == 1 &&
                                  ordersLate[index]?.late?.pos &&
                                  ordersLate[index]?.late?.hour == 0 &&
                                  ordersLate[index]?.late?.min < 21 &&
                                  order.driverId == null
                                  ? { backgroundColor: "#ffa" }
                                  : order.currentStatusId == 1 &&
                                    ((ordersLate[index]?.late?.pos &&
                                      ordersLate[index]?.late?.hour == 0 &&
                                      ordersLate[index]?.late?.min < 2) ||
                                      !ordersLate[index]?.late?.pos) &&
                                    order.driverId == null
                                    ? { backgroundColor: "#faa" }
                                    : {}
                              }
                            >
                              <td>{order.id}</td>
                              {/* <td>{order.id + ' ' + order.late?.hour  + ' ' + order.late?.min  + ' ' + (order.currentStatusId == 1 && ((order.late?.pos && order.late?.hour == 0 && order.late?.min < 2) || !order.late?.pos) && order.driverId == '')  }</td> */}
                              {/* <td>{order.orderDate}</td>  */}
                              {!user.partner ? (
                                <td>
                                  {order.customer ? (
                                    <Badge>
                                      <Trans>User</Trans>
                                    </Badge>
                                  ) : order.partnerId != null ? (
                                    <Badge>
                                      <Trans>Partner</Trans>
                                    </Badge>
                                  ) : (
                                    <Badge>
                                      <Trans>None</Trans>
                                    </Badge>
                                  )}{" "}
                                  <br />
                                  {order.customer ? (
                                    <Badge className="bg-success">
                                      <Trans>{order?.customer?.name}</Trans>
                                    </Badge>
                                  ) : order?.partnerId != null ? (
                                    <h5>
                                      <Badge className="bg-success">
                                        <Trans>{order?.partner?.name}</Trans>
                                      </Badge>
                                    </h5>
                                  ) : (
                                    <Badge>
                                      <Trans>None</Trans>
                                    </Badge>
                                  )}
                                </td>
                              ) : (
                                <></>
                              )}
                              {user.partner ? (
                                <td>
                                  {order.partnerBranch ? (
                                    <h5>
                                      <Badge className="bg-success">
                                        <Trans>
                                          {order?.partnerBranch?.name}
                                        </Trans>
                                      </Badge>
                                    </h5>
                                  ) : (
                                    <Badge>
                                      <Trans>None</Trans>
                                    </Badge>
                                  )}
                                </td>
                              ) : (
                                <></>
                              )}
                              <td>
                                {order.addressFrom
                                  ? order.addressFrom?.title +
                                  " " +
                                  order.addressFrom?.city?.name +
                                  " - " +
                                  order.addressFrom?.district?.name
                                  : ""}
                              </td>
                              <td>
                                {order.addressTo
                                  ? order.addressTo?.title +
                                  " " +
                                  order.addressTo?.city?.name +
                                  " - " +
                                  order.addressTo?.district?.name
                                  : ""}
                              </td>
                              <td>
                                {order.deliveryType
                                  ? order.deliveryType.nameTranslated
                                  : ""}
                              </td>
                              <td>
                                {order.createdAt
                                  ? order.createdAt.split("T")[0]
                                  : ""}
                              </td>
                              <td>
                                {order.createdAt
                                  ? new Date(order.createdAt).getHours() +
                                  ":" +
                                  new Date(order.createdAt).getMinutes()
                                  : ""}
                              </td>
                              <td>
                                <h5>
                                  <Badge className="bg-success">
                                    <Trans>
                                      {order.driver ? order.driver.name : ""}
                                    </Trans>
                                  </Badge>
                                </h5>
                              </td>
                              <td>{order.orderDate}</td>
                              <td>{order.orderTime}</td>
                              {/* <td>{order.expectedArrivalDuration}</td>
                            <td>{order.expectedDeliveryDuration}</td> */}
                              <td>
                                <div
                                  style={{
                                    backgroundColor: [1, 6].includes(
                                      order.currentStatus?.id
                                    )
                                      ? "#60b9ee"
                                      : "#faa",
                                    color: "black",
                                    padding: "7px",
                                  }}
                                >
                                  {order.currentStatus
                                    ? order.currentStatus?.name
                                    : ""}
                                </div>
                              </td>
                              {/* <td>
                              <div
                                style={{
                                  backgroundColor: ordersLate[index]?.late?.pos
                                    ? "#afa"
                                    : "#faa",
                                  color: "black",
                                  padding: "7px",
                                }}
                              >
                                {ordersLate[index]?.late?.val}
                              </div>
                            </td> */}
                              <td>{order.refCategoryType}</td>
                              <td>{order.packagesNo}</td>
                              <td>
                                <h5>
                                  <Badge className="bg-success">
                                    <Trans>
                                      {order.paymentStatus?.name}
                                    </Trans>
                                  </Badge>
                                </h5>
                              </td>
                              <td>{paymentMethods.find(el => el.value == order.paymentMethodId)?.label}</td>
                              <td>{order.refId}</td>
                              <td>{order.refAmount}</td>
                              <td>
                                <QRCode size={128} value={order.id?.toString()} />
                              </td>
                              {/* <td>{order.vehicleCategory.title}</td>  */}
                              {/* <td>{order.shipmentType.title}</td>  */}
                              <td>
                                <Link to={`/orders/edit/${order.id}`}>
                                  <button className="btn btn-sm btn-info">
                                    <i className="dripicons-pencil"></i> &nbsp;
                                    <Trans>Edit</Trans>
                                  </button>
                                </Link>
                                &nbsp;
                                <Link to={`/orders/mod-order/${order.id}/unfreeze`}>
                                  <button className="btn btn-sm btn-info">
                                    <i className="dripicons-snow"></i> &nbsp;
                                    <Trans>UnFreeze</Trans>
                                  </button>
                                </Link>
                                &nbsp;
                                <Link to={`/orders/mod-order/${order.id}/unassign`}
                                >
                                  <button className="btn btn-sm btn-info">
                                    <i className="dripicons-snow"></i> &nbsp;
                                    <Trans>Unassign Order</Trans>
                                  </button>
                                </Link>
                                &nbsp;
                                {!user.partner ? (
                                  <Link to={`/orders/remove/${order.id}/${order.currentStatusId}`}>
                                    <button className="btn btn-sm btn-danger">
                                      <i className="dripicons-trash"></i> &nbsp;
                                      <Trans>{order.currentStatusId == 7 ? 'Remove Cancellation' : 'Cancel'}</Trans>
                                    </button>
                                  </Link>
                                ) : (
                                  <></>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                  <br></br>
                  <div className="text-center">
                    {/* Pagination controls */}
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={handlePrevPage}
                      disabled={page === 1}
                    >
                      <Trans>Previous</Trans>
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={handleNextPage}
                      disabled={page === totalPages}
                    >
                      <Trans>Next</Trans>
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default OrdersList
